/* global Bouncer */
'use strict'
const formValidation = {
	fxValidations(form) {

		const invalidFormatMessage = form.data('msg-invalid-format'),
			requiredMessage = form.data('msg-required'),
			invalidDateMessage = form.data('msg-invalid-date'),
			rangeValidator = $.validator.methods.range

		//-extend jquery range validator to work for required checkboxes - !important - do not remove!
		$.validator.methods.range = function (value, element, param) {
			if (element.type === 'checkbox') {
				if (!element.checked) {
					const replace = $(element).attr('data-valmsg-replace')
					if (replace === 'true') {
						setTimeout(function () {
							$("[data-valmsg-for='" + $(element).attr('name') + "']")
								.children()
								.text($(element).attr('data-field-validation-message'))
						}, 1)
					}
				}
		
				// if it's a checkbox return true if it is checked
				return element.checked
			} else {
				// otherwise run the default validation function
				return rangeValidator.call(this, value, element, param)
			}
		}

		//-recaptcha
		$.validator.addMethod('recaptcha', () => {
			const grecaptcha = window.grecaptcha || null
			return !grecaptcha || grecaptcha.getResponse()
		})

		$.validator.addMethod('date', (value, element) => {
			const regex = /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/
			return regex.test(value)
		}, invalidDateMessage)

		$.validator.addMethod('dob-greater-than', function(value, element) {
			const maxDate = element.getAttribute('max') === 'today' ? new Date() : new Date(element.getAttribute('max').split('/')[2], element.getAttribute('max').split('/')[1] - 1, element.getAttribute('max').split('/')[0]),
				inputDate = new Date(value.split('/')[2], value.split('/')[1] - 1, value.split('/')[0])

			if(inputDate.getTime() <= maxDate.getTime()) {
				return value
			}
		}, form.data('msg-date-greater-than'))

		$.validator.addMethod('lettersonly', value => /^([^0-9]*)$/.test(value), invalidFormatMessage)

		$.validator.addMethod('email', function(value, element) {return this.optional(element) || /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])+/i.test(value)}, invalidFormatMessage)

		$.validator.addMethod('phone', value => /^(\+351|00351|351)?9[1236]\d{7}|[2|3]\d{8}$/.test(value), invalidFormatMessage)
		//^(\+351|00351|351)?[2|3|9][0-9]{8}$ - validate all PT phones
		//^(\+351|00351|351)?[9][0-9]{8}$ - validate only all PT mobile phones
		//^(\+351|00351|351)?[2|3][0-9]{8}$ - validate only all PT landline phones
		//(\+351|00351|351)?|9[1236]\d{7}|[2|3]\d{8} - validate all PT phones (landline and mobile numbers with or without +351 or 00351 or 351 prefix starting with 2 or 3 or 91 92 93 96)))))))			

		$.validator.addMethod('passport', value => /^(?!^0+$)[a-zA-Z0-9]{3,20}$/.test(value), invalidFormatMessage) // validate all passports
		
		$.validator.addMethod('checkbox-required', value => typeof(value) !== 'undefined', requiredMessage)

		$.validator.addMethod('nif', value => {
			//FIX IE for includes method
			if (!Array.prototype.includes) {
				Object.defineProperty(Array.prototype, 'includes', {
					enumerable: false,
					value: function(obj) {
						const newArr = this.filter(el => {
							return el == obj
						})
						return newArr.length > 0
					}
				})
			}

			if (value += '', !['1', '2', '3', '5', '6', '8'].includes(value.substr(0, 1)) && !['45', '70', '71', '72', '77', '79', '90', '91', '98', '99'].includes(value.substr(0, 2))) return !1
			let d, b = 9 * value[0] + 8 * value[1] + 7 * value[2] + 6 * value[3] + 5 * value[4] + 4 * value[5] + 3 * value[6] + 2 * value[7],
				c = b - 11 * parseInt(b / 11)
			return (d = 1 == c || 0 == c ? 0 : 11 - c, value[8] == d)
		}, invalidFormatMessage)

		$.validator.addMethod('bi', (value) => {
			let numberBI = value.replace(/-|\s/g, ''),
				sum = 0

			numberBI = [...numberBI]
			const checkDigit = parseInt(numberBI.pop())

			numberBI = numberBI.reverse()

			$.each(numberBI, (key, val) => sum += (key + 2) * val)

			return ((sum + checkDigit) % 11 == 0) || (checkDigit == 0 && (sum + 10) % 11 == 0)
		}, invalidFormatMessage)

		$.validator.addMethod('cc', value => {
			const letterValue = {
				A: 10,
				B: 11,
				C: 12,
				D: 13,
				E: 14,
				F: 15,
				G: 16,
				H: 17,
				I: 18,
				J: 19,
				K: 20,
				L: 21,
				M: 22,
				N: 23,
				O: 24,
				P: 25,
				Q: 26,
				R: 27,
				S: 28,
				T: 29,
				U: 30,
				V: 31,
				W: 32,
				X: 33,
				Y: 34,
				Z: 35
			}
			let numberCC = value.replace(/-|\s/g, ''), // remove space and -
				sum = 0,
				dum = 0

			numberCC = numberCC.toUpperCase()
			numberCC = [...numberCC]
			numberCC = numberCC.reverse()
			numberCC[1] = letterValue[numberCC[1]]
			numberCC[2] = letterValue[numberCC[2]]

			$.each(numberCC, (key, val) => {
				if (key % 2 == 0)
					dum = parseInt(val)
				else {
					dum = parseInt(val) * 2
					if (dum >= 10)
						dum -= 9
				}
				sum += dum
			})

			return (sum % 10 === 0) ? true : false
		}, invalidFormatMessage)
	}
}